import { useNavigate } from 'react-router-dom';

import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
} from 'shared/lib';

import { RoleForm, RoleFormData, useAddRoleMutation } from 'entities/role';

import { ADD_SUCCESS, ADD_ERROR } from '../consts';
import { ROLE_ROUTES } from 'shared/consts/routes/role';

const initialValues: RoleFormData = {
  id: '',
  name: '',
};

export function AddRole() {
  const [trigger, { isLoading }] = useAddRoleMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: RoleFormData) => {
    const { name } = values;

    try {
      const res = await trigger({ name }).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      navigate(ROLE_ROUTES.ROLES);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <RoleForm
      title="Добавление новой роли"
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
    />
  );
}
